<template>
    <div class="otp-container">
      <input
        v-for="(digit, index) in otpArray"
        :key="index"
        type="text"
        class="otp-box"
        v-model="otpArray[index]"
        maxlength="1"
        ref="otpInputs"
        @input="moveToNext(index, $event)"
        @keydown.backspace="moveToPrev(index, $event)"
      />
    </div>
  </template>
  
  <script>
  export default {
    props: {
      otpLength: {
        type: Number,
        default: 6, // Default length is 6 digits
      },
    },
    data() {
      return {
        otpArray: Array(this.otpLength).fill(""),
      };
    },
    watch: {
      otpArray: {
        deep: true,
        handler(newVal) {
          this.$emit("updateOtp", newVal.join(""));
        },
      },
    },
    methods: {
      moveToNext(index, event) {
        if (event.target.value && index < this.otpLength - 1) {
          this.$refs.otpInputs[index + 1].focus();
        }
      },
      moveToPrev(index, event) {
        if (!event.target.value && index > 0) {
          this.$refs.otpInputs[index - 1].focus();
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .otp-container {
    display: flex;
    justify-content: center;
    gap: 5px;
  }
  
  .otp-box {
    width: 40px;
    height: 40px;
    font-size: 20px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  </style>
  